const articles = [
  {
    id: 1,
    author: 'Olivera Kegey RD, Specialist Dietitian, Akai House Clinic',
    slug: 'top-5-tips-for-eating-and-living-well',
    title: 'TOP 5 TIPS FOR EATING AND LIVING WELL!',
    synopsis:
      'These five practical tips can help you make healthier food choices, eat well and live well.',
    content: `
        <h3>1. Eat more plant foods for good health!</h3>  
        <p>Well balanced plant-based diets are better 
        for overall good health than a meat-based diets according to recent scientific studies. 
        Include a wide variety of fruits, vegetables, beans, nuts, seeds and whole grains and 
        a modest amount of fish and a small amount of meat in your diet.  
        Plant-based diets can help protect against high blood pressure, high blood cholesterol, 
        heart disease, some cancers, obesity, type 2 diabetes and mental decline as you get older.
        </p>
        <h3>2. Eat a “Super Diet” by including these nutrient-packed foods!</h3>
        <p>Some foods sometimes referred to as
        “superfoods” have special and unique nutritional properties that benefits to our health. 
        The nutrients contained within these foods may be beneficial in good digestive health,
        enhance the immune system, strengthen bones and protect against heart disease, cancer
        and the effects of the aging.
        </p>
        <p>
        For a “Super Diet”, include a wide variety of these special nutrient-rich foods in your diet.
        <ul>
            <li><strong class="akai-color1">Avocado Pear</strong></li>
            <li><strong class="akai-color1">Natural Yoghurt</strong></li>
            <li><strong class="akai-color1">Beans, Peas and Lentils</strong></li>
            <li><strong class="akai-color1">Nuts</strong> such as peanuts, brazil nuts and almonds</li>
            <li><strong class="akai-color1">Edible seeds</strong> such as melon, chia, flax , sunflower and sesame seeds</li>
            <li><strong class="akai-color1">Soybeans</strong></li>
            <li><strong class="akai-color1">Whole grains</strong> such as whole wheat, brown rice, whole maize (corn), millet, sorghum and quinoa.</li>
            <li><strong class="akai-color1">Oats</strong> </li>
            <li><strong class="akai-color1">Naturally oily fish</strong>, rich in omega-3 fats such as  sardines, mackerel, tuna and herrings</li> 
            <li><strong class="akai-color1">Cruciferous vegetables</strong> such as cabbage and broccoli</li> 
        </ul>
        Enjoy a wide range of both local and foreign varieties readily available on the market!
        </p>
        <img src="/img/articles/fruit.jpg" alt="article image" class="img-fluid my-5"/>
        <h3>3. Balance the foods on your plate for optimum body function.</h3>
        <p>A balanced plate consists of one quarter plate of wholegrains and other starchy carbohydrates; 
        one quarter plate of healthy protein foods such as fish, lean chicken and beans; half plate of 
        vegetables and a side fruit snack or dessert. Focusing on these proportions for  at least two
        meals a day ensures  you have an adequate intake of key nutrients such as proteins, carbohydrates,
        fats, vitamins, minerals, fibre and other plant chemicals necessary for optimum body function.
        </p>
        <h3>4. Swap the processed and overcooked foods for whole natural foods.</h3>
        <p>Processed foods are often high in unhealthy fats, salt, refined sugars and low in vitamins and minerals.
        They include pastries; chips and crisps; cakes and biscuits; bacon, sausage, corned beef and burgers;
        “convenience foods", such as fast foods and ready-to-eat meals. 
        The more a food is processed or cooked for long periods, the more of its nutritional goodness is lost.
        Quick cooking methods such as steaming, grilling and stir-frying are best for preserving nutritional
        goodness in most foods.
        </p>
        <h3>5. Regular brisk walking for at least 150 minutes per week works!</h3>
        <p>Going for a brisk walk can help you, lower your blood pressure;
        reduce the risk of many diseases such as heart disease, type 2 diabetes and some cancers;
        maintain a healthy weight and lower your stress levels.
        </p>
    `,
    image: '/img/articles/fruit.jpg'
  }
]

module.exports = articles
